module.exports = __webpack_public_path__ + "img/verbena-pink.d757fc00.jpg";